module.exports = __webpack_public_path__ + "static/media/logo-grey-small.8450eab9.png";